import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const VEHICLES = `${PRIVATE_ROOT}/apartment/vehicles`
export const ADD_VEHICLE = `${PRIVATE_ROOT}/apartment/vehicles/add`
export const EDIT_VEHICLE = `${PRIVATE_ROOT}/apartment/vehicles/:id/edit`
